import { Spinner } from "@/components/ui/spinner";

export const LoadingState = () => {
    return (
        <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background/80 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-4 animate-fade-in">
                <Spinner size="xl" />
                <p className="text-muted-foreground font-medium animate-pulse">جاري التحميل...</p>
            </div>
        </div>
    );
};
